import { Link } from 'react-router-dom';

export const KontaktErfolg = () => (
  <>
    <section className="page-hero page-hero--small" id="top">
      <div className="container page-hero__inner">
        <div>
          <span className="section__eyebrow section__eyebrow--on-dark">Nachricht gesendet</span>
          <h1>Danke! Ihre Anfrage ist angekommen.</h1>
          <p className="page-hero__lead">
            Wir melden uns zeitnah bei Ihnen.
          </p>
        </div>
        <a className="btn btn--light" href="tel:+4915758166291">
          Jetzt anrufen
        </a>
      </div>
    </section>

    <section className="section section--light">
      <div className="container">
        <div className="grid grid--services">
          <article className="card card--service">
            <div className="card__header">
              <span className="card__eyebrow">Direkter Kontakt</span>
              <h2 className="card__title">Noch etwas ergänzen?</h2>
            </div>
            <p className="card__lead">
              Wenn Sie weitere Details haben, erreichen Sie uns am schnellsten telefonisch oder per E-Mail.
            </p>
            <p className="card__lead">
              Staisch Innovative Elektrotechnik
              <br />
              Freiherr-vom-Stein-Straße 14
              <br />
              72654 Neckartenzlingen
            </p>
            <div className="card__actions">
              <a className="card__cta" href="tel:+4915758166291">
                01575 8166291 anrufen
              </a>
              <a className="card__cta" href="mailto:info@staisch-elektrotechnik.de">
                info@staisch-elektrotechnik.de
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  </>
);
